import React from 'react';

interface PublicationItemProps {
    bulletStyle: string;
    title: string;
    authors: React.ReactNode;
    conference: string;
    conferenceLink: string;
    date: string;
    link?: string;
    isMobile?: boolean;
}

const PublicationItem: React.FC<PublicationItemProps> = ({
    bulletStyle,
    title,
    authors,
    conference,
    conferenceLink,
    date,
    link,
    isMobile = false,
}) => {
    const marginLeft = isMobile ? '0.5rem' : '2rem';

    return (
        <li className={`relative pl-6 mb-4 ${bulletStyle}`} style={{ marginLeft }}>
            {link ? (
                <span className='text-textRed hover:underline'>
                    <a href={link}>
                        <b>{title}</b>
                    </a>
                </span>
            ) : (
                <span className='text-textRed'>
                    <b>{title}</b>
                </span>
            )}
            <br />
            <span className='font-extralight'>{authors}</span>
            <br />
            <span className='text-textRed hover:underline'>
                <a href={conferenceLink}>
                    <i>{conference}</i>
                </a>
            </span>
            <br />
            {date}
        </li>
    );
};

export default PublicationItem;